import React from "react";
import LikeIcon from "../assests/home/handstar.png";
import KeyIcon from "../assests/home/lock.png";
import RecoveryIcon from "../assests/home/recovery.png";
import SettingIcon from "../assests/home/setting.png";
import UpdateIcon from "../assests/home/withdraw.png";
import "../components/custom.css";
import Card from "./Card";

const NewHomie = () => {
  return (
    <div className="md:px-10">
      <div className="grid  grid-cols-1 gap-8 mt-4 sm:grid-cols-2 md:grid-cols-3">
        <Card
          imageUrl={SettingIcon}
          captionLine="RETIFICATION"
          commentLine="Retification support warranties completely decentralized"
          buttonSpace="RETIFICATION"
        />
        <Card
          imageUrl={KeyIcon}
          captionLine="VALIDATION"
          commentLine="Validation completely decentralized support wallet"
          buttonSpace="VALIDATION"
        />
        <Card
          imageUrl={RecoveryIcon}
          captionLine="RECOVERY"
          commentLine="Recovery wallet TATs Dapps with Blockchain and DeFi"
          buttonSpace="RECOVERY"
        />
        <Card
          imageUrl={KeyIcon}
          captionLine="MY NFTS"
          commentLine="View your collection of digital works"
          buttonSpace="VIEW"
        />
        <Card
          imageUrl={SettingIcon}
          captionLine="WHITELIST"
          commentLine="Get a Early Spot for Minting"
          buttonSpace="WHITELIST"
        />
        <Card
          imageUrl={SettingIcon}
          captionLine="PURCHASE TOKEN"
          commentLine="Also, buy bitcoin, ether, and many common crypocurrencies"
          buttonSpace="BUY"
        />
        <Card
          imageUrl={LikeIcon}
          captionLine="HARVEST MY STAKINGS"
          commentLine="When you choose to redeem, we'll return your assets to your Spot Wallet the following day"
          buttonSpace="HARVEST"
        />
        <Card
          imageUrl={UpdateIcon}
          captionLine="UPDATE MY PORTFOLIOS"
          commentLine="Generate Real-Time Profit and Loss Reports, Your Coin Values, Reports for Taxes and More."
          buttonSpace="GENERATE"
        />
        <Card
          imageUrl={LikeIcon}
          captionLine="ADD TOKENS"
          commentLine="Cryptotokens are type of cryptocurrenciesthat represents an asset or specific use and reside on their own blockchain."
          buttonSpace="ADD"
        />
        <Card
          imageUrl={KeyIcon}
          captionLine="REVIEW MY NFTS"
          commentLine="NFTs are digital collectibles that can be traded like other cryptocurrencies. They confer some ownership rights to a work"
          buttonSpace="REVIEW"
        />
        <Card
          imageUrl={SettingIcon}
          captionLine="STAKING POOL"
          commentLine="A staking pool allows multiple stakeholders (or bagholders) to combine their computational resources as a way to increase their chances of being rewarded"
          buttonSpace="STAKING POOL"
        />
        <Card
          imageUrl={UpdateIcon}
          captionLine="WITHDRAWAL"
          commentLine="A crypto withdrawal is a transaction that allow you  to move your cryptocurrency balance off the Revolut platform to an external crypto wallet that you control such as a Ledger or a Trezor"
          buttonSpace="WITHDRAWAL"
        />
        <Card
          imageUrl={RecoveryIcon}
          captionLine="STAKING REVIEW"
          commentLine="Interaction between mobile apps and mobile browers are supported via mobile deep linking Having complete control of your staking"
          buttonSpace="STAKING REVIEW"
        />
        <Card
          imageUrl={LikeIcon}
          captionLine="BRIDGE"
          commentLine="enables applications built on different blockchains to communicate with and interact with each other, something which was never before possible, therefore unlocks a groundbreaking development for the blockchain space as a whole. On launch, Ethereum, BSC, Avalanche, and Polygon - four of the leading blockchains and protocols - are supported, with capabilities to add new blockchains built-in to the Alliance Bridge protocol."
          buttonSpace="BRIDGE"
        />
      </div>
    </div>
  );
};

export default NewHomie;
